import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { findRouteMeta, SITE_URL } from "./routes";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

function setJsonLd(data) {
  document.head.querySelectorAll('script[type="application/ld+json"]').forEach((e) => e.remove());
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.textContent = JSON.stringify(data);
  document.head.appendChild(s);
}

export default function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const m = findRouteMeta(pathname);
    if (!m) return;
    const url = `${SITE_URL}${m.path}`;
    document.title = m.title;
    setMeta("name", "description", m.description);
    setMeta("property", "og:title", m.title);
    setMeta("property", "og:description", m.description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", m.title);
    setMeta("name", "twitter:description", m.description);
    setMeta("name", "geo.region", m.geo.region);
    setMeta("name", "geo.placename", m.geo.placename);
    setMeta("name", "geo.position", m.geo.position);
    setMeta("name", "ICBM", m.geo.icbm);
    setCanonical(url);
    setJsonLd(m.jsonLd);
  }, [pathname]);

  return null;
}
